<template>
  <div>
    <v-dialog
      v-model="dialog_pr_setting"
      scrollable
      persistent
      max-width="1000px"
      transition="dialog-transition"
    >
      <v-card>
        <!-- <pre>{{pr_list}}</pre> -->
        <v-card-title primary-title style="background-color:rgba(227, 236, 238, 0.9);">
          ตั้งค่าประชาสัมพันธ์
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="dialog_pr_setting = false">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card class="pt-2 my-3 mt-6" outlined>
            <v-card-title class="justify-center main-title pb-0">ประชาสัมพันธ์ทั้งหมด</v-card-title>

            <v-data-table :headers="pr_headers" :items="pr_list">
              <!-- dialog -->
              <template v-slot:top>
                <v-col align="right">
                  <v-btn @click="dialogAddEdit('')" color="primary" dark>
                    <v-icon class="mr-2">mdi-plus-circle</v-icon>เพิ่มประชาสัมพันธ์
                  </v-btn>
                </v-col>

                <v-dialog
                  v-model="dialog_add_edit"
                  width="700"
                  persistent
                  content-class="alldialog_settings"
                >
                  <v-card>
                    <v-card-title style="background-color:rgba(227, 236, 238, 0.9);">
                      <span class="font-weight-bold">{{ formTitle }}</span>
                      <v-spacer></v-spacer>
                      <v-btn icon class="float-right" @click="close()">
                        <v-icon>mdi-window-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-form ref="form" @submit.prevent="save()">
                      <v-card-text class="pb-0 pt-2">
                        <v-select v-model="item_seq" :items="items" label="ลำดับ" dense outlined></v-select>
                        <v-text-field
                          :rules="rule_field_is_empty"
                          required
                          v-model="pr_name"
                          label="หัวข้อ"
                          outlined
                        ></v-text-field>
                        <!-- <v-textarea
                          :rules="rule_field_is_empty"
                          required
                          v-model="pr_detail"
                          label="Detail"
                          outlined
                        ></v-textarea>-->
                        <quill-editor
                          ref="myQuillEditor"
                          class="ql-container ql-formats"
                          v-model="pr_detail"
                          :options="editorOption"
                        ></quill-editor>
                        <!-- <pre>{{file_image}}</pre> -->

                        <v-row class="py-6" v-if="show_upload">
                          <v-col cols="12" class="py-0">
                            <v-card outlined style="border:1px solid rgba(0, 0, 0, 0.38);">
                              <label :for="namephotofile">
                                <p class="pt-5 px-3 py-1">
                                  อัปโหลดรูปภาพ
                                  <v-icon class="float-right">mdi-cloud-upload</v-icon>
                                </p>
                              </label>
                            </v-card>
                          </v-col>
                        </v-row>
                        <!-- <pre>{{file_image_from_api_type}}</pre> -->
                        <v-row>
                          <v-col
                            cols="12"
                            align="center"
                            justify="center"
                            v-if="file_image_from_api"
                          >
                            <v-card class="text-center pa-1 pt-3 ma-1">
                              <v-card-title class="py-0">
                                <v-spacer></v-spacer>
                                <v-btn small icon @click="removeImage(index)">
                                  <v-icon small class="float-right">mdi-window-close</v-icon>
                                </v-btn>
                              </v-card-title>
                              <img
                                class="float-center"
                                v-if="file_image_from_api && file_image_from_api_type!= 'video/mp4'"
                                :src="env+'/'+file_image_from_api"
                                height="320px"
                                width="540px"
                              />
                              <video
                                class="float-center"
                                v-if="file_image_from_api && file_image_from_api_type== 'video/mp4'"
                                :src="env+'/'+file_image_from_api"
                                height="320px"
                                width="540px"
                              />
                            </v-card>
                          </v-col>
                          <!-- <pre>{{file_image}}</pre> -->
                          <v-col
                            v-show="file_image!=[]"
                            cols="12"
                            align="center"
                            justify="center"
                            v-for="(file, index) in file_image"
                            :key="index"
                          >
                            <v-card class="text-center pa-1 pt-3 ma-1">
                              <v-card-title class="py-0">
                                <v-spacer></v-spacer>
                                <v-btn small icon @click="removeImage(index)">
                                  <v-icon small class="float-right">mdi-window-close</v-icon>
                                </v-btn>
                              </v-card-title>
                              <img
                                class="float-center"
                                v-if="file.thumb&&file.type!='video/mp4'"
                                :src="file.thumb"
                                height="320px"
                                width="540px"
                              />
                              <video
                                class="float-center"
                                v-if="file.blob&&file.type=='video/mp4'"
                                :src="file.blob"
                                height="320px"
                                width="540px"
                              />
                            </v-card>
                          </v-col>
                        </v-row>
                        <p
                          v-if="file_image==''&&file_image_from_api==''"
                          class="pa-0"
                          style="color:red; font-size:12px; margin-top:-2%;"
                        >* กรุณาใส่รูปภาพ</p>

                        <file-upload
                          class="btn btn-primary dropdown-toggle"
                          input-id="photofile"
                          :directory="directory"
                          :accept="acceptphoto"
                          :extensions="extensionsphoto"
                          :size="size || 0"
                          :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
                          :headers="headers"
                          :data="data"
                          :drop="drop"
                          :multiple="multiple"
                          @input-filter="inputFilter"
                          v-model="file_image"
                          @input-file="inputFile"
                          ref="pr_media"
                        ></file-upload>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="close">ยกเลิก</v-btn>
                        <v-btn color="primary" type="submit" :loading="click" text>บันทึก</v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </template>
              <!-- detail in dataTable -->
              <template v-slot:item.no="{ item }">{{ pr_list.indexOf(item) + 1 }}.</template>
              <template v-slot:item.information_name="{item}">
                <span v-html="showString(item.information_name,30)"></span>
              </template>
              <template v-slot:item.information_detail="{item}">
                <span v-html="showString(item.information_detail,70)"></span>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn icon @click="dialogAddEdit(item,pr_list.indexOf(item) + 1)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="deleteData(item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
              <template v-slot:item.image="{ item }">
                <v-card tile class="ma-1">
                  <v-img
                    v-if="item.information_file_type!='video/mp4'"
                    :src="env+'/'+item.information_file_path"
                    aspect-ratio="1"
                  ></v-img>
                  <video
                    v-if="item.information_file_type=='video/mp4'"
                    :src="env+'/'+item.information_file_path"
                    width="180px"
                    height="180px"
                  ></video>
                </v-card>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import FileUpload from "vue-upload-component";
export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      items: [],
      item_seq: 1,
      click: false,
      rule_field_is_empty: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      show_upload: true,
      env: process.env.VUE_APP_API,
      minSize: 1024,
      size: 1024 * 1024 * 10,
      multiple: false,
      acceptphoto: "image/png,image/gif,image/jpeg,image/jpg,video/mp4", //,video/mp4,video/x-m4v,video/*
      extensionsphoto: "gif,jpg,jpeg,png",
      directory: false,
      drop: false,
      thread: 3,
      postAction: "/upload/post",
      headers: {
        "X-Csrf-Token": "xxxx",
      },
      data: {
        _csrf_token: "xxxxxx",
      },
      autoCompress: 1024 * 1024,
      uploadAuto: true,
      namephotofile: "photofile",
      editedIndex: -1,
      delete_img_id: -1,
      dialog_add_edit: false,
      formTitle: "",
      file_image: [],
      file_image_from_api: "",
      file_image_from_api_type: "",
      media_id: null,
      pr_detail: "",
      pr_name: "",
      header_token: {
        headers: { Authorization: "Bearer " + this.$session.get("token") },
      },
      dialog_pr_setting: false,
      dialog: false,
      pr_headers: [
        {
          text: "ลำดับ",
          value: "no",
          sortable: false,
          align: "center",
          width: "10%",
        },

        {
          text: "รูปภาพ",
          value: "image",
          sortable: false,
          align: "center",
          width: "20%",
        },
        {
          text: "หัวข้อ",
          value: "information_name",
          sortable: false,
          align: "left",
          width: "20%",
        },
        {
          text: "รายละเอียด",
          value: "information_detail",
          sortable: false,
          align: "left",
          width: "30%",
        },
        {
          text: "จัดการ",
          value: "action",
          sortable: false,
          align: "center",
          width: "15%",
        },
      ],
      pr_list: [],
      edit_img: "",

      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            // [{ header: 1 }, { header: 2 }],

            // [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
            // ['link', 'image', 'video']
            ["link"],
          ],
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value,
          },
        },
      },
    };
  },
  created() {
    this.getInformation();
  },
  methods: {
    openSetting() {
      this.dialog_pr_setting = true;
    },
    close() {
      this.click = false;
      this.edit_img = "";
      this.pr_name = "";
      this.pr_detail = "";
      this.show_upload = true;
      this.editedIndex = -1;
      this.$refs.pr_media.remove(this.file_image[0]);
      this.dialog_add_edit = false;

      // this.clear();
    },
    inputFile(newFile) {},
    inputFilter(newFile, oldFile, prevent) {
      this.show_upload = false;
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
    getInformation() {
      let information = [];
      let information_detail = {};
      let all_information = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/information/all")
        .then((response) => {
          // console.log(response.data);

          information = response.data;
          // information.forEach((element) => {
          //   this.axios
          //     .get(
          //       process.env.VUE_APP_API +
          //         "/api/v1/information_join/" +
          //         element.information_id
          //     )
          //     .then((response) => {
          //       // console.log(response.data);

          //       information_detail = response.data;
          //       this.items.push(index_items);
          //       index_items++;
          //       all_information.push(information_detail);
          //     });
          // });
          // let data_information = [];
          // all_information.forEach((element, index) => {
          //   element.index = index;
          //   all_information.push(element);
          // });
          // this.items.push(index_items);
          this.pr_list = information;
          // console.log(this.pr_list);
        });
    },
    dialogAddEdit(item, index_of_element) {
      this.items = [];
      let index_items = 1;
      for (let index = 1; index <= this.pr_list.length; index++) {
        this.items.push(index);
        // console.log(index);
      }
      // console.log(index_of_element);
      setTimeout(() => {
        // this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }, 100);
      // console.log(item);
      if (item == "") {
        //add
        this.items.push(this.items.length + 1);
        // console.log(this.items.length + 1);
        this.item_seq = this.items.length;
        this.editedIndex = -1;
        this.formTitle = "เพิ่มประชาสัมพันธ์";
        this.file_image = [];
        this.pr_detail = "";
        this.pr_name = "";
        this.media_id = null;
        this.file_image_from_api = "";
        this.file_image_from_api_type = "";
        this.dialog_add_edit = true;
        this.show_upload = true;
        this.edit_img = "";
      } else if (item.information_id >= 0) {
        this.edit_img = "";
        // console.log(item);
        //edit
        this.item_seq = index_of_element;
        this.delete_img_id = item.information_file_id;
        this.editedIndex = item.information_id;
        this.formTitle = "แก้ไขประชาสัมพันธ์";

        this.file_image = [];
        this.file_image_from_api = item.information_file_path;
        this.file_image_from_api_type = item.information_file_type;
        this.media_id = item.media_id;
        if (this.file_image_from_api != "") {
          this.show_upload = false;
        }
        this.pr_detail = item.information_detail;
        this.pr_name = item.information_name;
        this.dialog_add_edit = true;
      }
    },
    removeImage() {
      this.file_image ? this.$refs.pr_media.remove(this.file_image[0]) : "";
      this.file_image = [];
      this.show_upload = true;
      this.file_image_from_api = "";
      this.file_image_from_api_type = "";
      this.edit_img = "delete";
    },

    save() {
      // console.log("save");

      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          if (this.edit_img == "delete") {
            if (this.$refs.pr_media.files != "") {
              this.click = true;
              this.putPR(this.editedIndex);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "กรุณาตรวจสอบไฟล์ภาพ หรือ ข้อมูล",
                showConfirmButton: false,
                timer: 1000,
              });
            }
          } else {
            this.click = true;
            this.putPR(this.editedIndex);
          }
        } else {
          if (
            this.file_image != [] &&
            this.$refs.form.validate() &&
            this.$refs.pr_media.files != ""
          ) {
            this.postPR();
          } else {
            this.$swal.fire({
              icon: "error",
              title: "กรุณาตรวจสอบไฟล์ภาพ หรือ ข้อมูล",
              showConfirmButton: false,
              timer: 1000,
            });
          }
        }
      } else {
        this.$swal.fire({
          icon: "error",
          title: "กรุณาตรวจสอบไฟล์ภาพ หรือ ข้อมูล",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    },
    postPR() {
      this.click = true;
      let data = {
        information_name: this.pr_name,
        information_detail: this.pr_detail,
        item_seq: this.item_seq,
        creator: "test",
      };
      let information_id = "";
      // console.log(data);

      if (this.file_image.length != 0) {
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v1/information/",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data);

            if (response.data.message == "create success") {
              information_id = response.data.informationid;
              this.postPRFile(information_id);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "ไม่สามารถเพิ่มข้อมูลได้",
                showConfirmButton: false,
                timer: 1000,
              });
            }
          });
      }
    },
    putPR(id) {
      let data = {
        information_name: this.pr_name,
        information_detail: this.pr_detail,
        item_seq: this.item_seq,
        creator: "test",
      };
      this.axios
        .put(
          process.env.VUE_APP_API + "/api/v1/information/" + id,
          data,
          this.header_token
        )
        .then((response) => {
          // console.log(response.data);
          if (response.data == "edit success") {
            if (this.edit_img == "delete") {
              // console.log(this.edit_img);
              this.deleteImg();
            } else {
              this.$swal.fire({
                icon: "success",
                title: "แก้ไขข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
              this.click = false;

              // form = new FormData();
              this.getInformation();
              this.close();
              this.$emit("getpr", "edit");
              // }
            }
          }
        });
    },
    postPRFile(id) {
      let form = new FormData();
      if (this.file_image.length != 0) {
        form = new FormData();
        form.append("file", this.file_image[0].file);
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v1/information_file/" + id,
            form,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data);

            if (response.data == "upload success") {
              this.$swal.fire({
                icon: "success",
                title: "เพิ่มข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
              this.click = false;

              form = new FormData();
              this.getInformation();
              this.close();
              this.$emit("getpr", "add");
            } else {
              this.$swal.fire({
                icon: "error",
                title: "ไม่สามารถเพิ่มข้อมูลได้",
                showConfirmButton: false,
                timer: 1000,
              });
              form = new FormData();
              this.getInformation();
              this.close();
              this.$emit("getpr", "add");
            }
          });
      }
    },
    deleteImg() {
      this.axios
        .delete(
          process.env.VUE_APP_API +
            "/api/v1/information_file/" +
            this.delete_img_id,
          this.header_token
        )
        .then((response) => {
          // console.log(response);
          if (response.data == "delete success") {
            if (
              this.file_image.length != 0 &&
              this.$refs.pr_media.files != ""
            ) {
              // console.log(this.file_image[0].file);
              let form;
              form = new FormData();
              form.append("file", this.file_image[0].file);
              this.axios
                .post(
                  process.env.VUE_APP_API +
                    "/api/v1/information_file/" +
                    this.editedIndex,
                  form,
                  this.header_token
                )
                .then((response) => {
                  // console.log(response.data);

                  if (response.data == "upload success") {
                    this.$swal.fire({
                      icon: "success",
                      title: "แก้ไขข้อมูลสำเร็จ",
                      showConfirmButton: false,
                      timer: 1000,
                    });
                    this.click = false;

                    form = new FormData();
                    this.getInformation();
                    this.close();
                    this.$emit("getpr", "edit");
                  } else {
                    this.$swal.fire({
                      icon: "error",
                      title: "ไม่สามารถเพิ่มข้อมูลได้",
                      showConfirmButton: false,
                      timer: 1000,
                    });
                    form = new FormData();
                    this.getInformation();
                    this.close();
                    this.$emit("getpr", "edit");
                  }
                });
            }
          }
        });
    },
    deleteData(item) {
      this.$swal
        .fire({
          title: "ต้องการลบรายการนี้ใช่หรือไม่?",
          text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#E53935",
          cancelButtonColor: "#9E9E9E",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((res) => {
          if (res.value) {
            this.axios
              .delete(
                process.env.VUE_APP_API +
                  "/api/v1/information/" +
                  item.information_id,
                this.header_token
              )
              .then((response) => {
                if (response.data) {
                  if (response.data === "delete success") {
                    this.$swal.fire({
                      icon: "success",
                      title: "ลบข้อมูลสำเร็จ",
                      showConfirmButton: false,
                      timer: 1000,
                    });
                    this.getInformation();
                    this.$emit("getpr", "delete");
                  } else {
                    this.$swal.fire("ไม่สามารถลบได้", "", "error");
                  }
                }
              });
          }
        });
    },
    showString(str, length) {
      // parameter invalid
      if (!str) return "";
      if (!length) return str;
      // parameter is validate
      if (str.length > length) return str.substring(0, length) + " ...";
      else return str;
    },
  },
};
</script>
<style lang="scss">
// style text editor
.announcement_btn_bar {
  background-image: linear-gradient(#ffffff, #cccccc);
  font-size: 9px;
}
.ql-toolbar {
  background-image: linear-gradient(#e5e5e5, white);
}
.ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
  border: 1px solid #bec0c2;
}
.quill-code {
  border: none;
  height: auto;
  > code {
    width: 100%;
    margin-top: 50px;
    padding: 1rem;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0;
    height: 10rem;
    overflow-y: auto;
    resize: vertical;
  }
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
  height: 250px;
}
</style>